import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'splitCamelCase'
})
export class SplitCamelCasePipe implements PipeTransform {

  transform(value: string, trimCount?:number): string {
    if(!trimCount || trimCount <= 0) return value.replace(/([A-Z])/g, ' $1').trim();
    const stringArr = value.replace(/([A-Z])/g, ' $1').trim().split(' ');
    return stringArr.slice(0, trimCount).join(' ');
  }
}
